import React, { useEffect } from 'react'

import qs from 'query-string'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import useAuthSupplier from 'hooks/useAuthSupplier'

import * as service from 'service'

const DefaultComponent = ({ children }) => <>{children}</>

const SupplierRouteWithLayout = ({
  auth,
  layout,
  provider,
  component: Component,
  permission,
  somePermissions,
  reduceMargin,
  admin = false,
  redirect = true,
  ...rest
}) => {
  const Layout = layout || DefaultComponent
  const Providers = Array.isArray(provider)
    ? provider
    : [provider || DefaultComponent]
  const search = qs.parse(rest.location.search)
  const isAuthenticated = service.supplierPortal.auth.isAuthenticated()
  const { homeRoute, loadOut } = useAuthSupplier()

  useEffect(() => {
    const defineToken = async () => {
      service.supplierPortal.auth.setToken(search.redirect_token)
      service.history.push(homeRoute)
    }

    if (search.redirect_token) {
      defineToken()
    }
  })

  const wrapWithProviders = (providers, children) => {
    return providers.reduceRight(
      (acc, Provider) => <Provider>{acc}</Provider>,
      children,
    )
  }

  if (isAuthenticated) {
    if (redirect) {
      if (!auth) {
        if (homeRoute) {
          service.history.push(homeRoute)
          return null
        }
      }
    }
  } else {
    if (auth) {
      service.supplierPortal.auth.logout()
      loadOut()
      return null
    }
  }

  const renderRoute = (matchProps) => {
    return wrapWithProviders(
      Providers,
      <Layout
        permission={permission}
        somePermissions={somePermissions}
        reduceMargin={reduceMargin}
        admin={admin}
        auth={auth}
      >
        <Component {...matchProps} />
      </Layout>,
    )
  }

  return <Route {...rest} render={(matchProps) => renderRoute(matchProps)} />
}

SupplierRouteWithLayout.propTypes = {
  component: PropTypes.any,
  layout: PropTypes.any,
  path: PropTypes.string,
  permission: PropTypes.string,
  admin: PropTypes.bool,
}

export default SupplierRouteWithLayout
